
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    '& > * + *': {
    
    },
  },
  custom: {
    color: '#91a2b9',
    animationDuration: '550ms',
  },
}));

export default function ExportSpinner(props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <CircularProgress
        variant="indeterminate"
        disableShrink
        className={classes.custom}
        size={props.size}
        thickness={props.thickness}
      />
    </div>
  );
}
